"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.onInit = exports.APP_INIT = void 0;
var APP_INIT = exports.APP_INIT = 'APP_INIT';
var onInit = exports.onInit = function onInit() {
  return {
    type: APP_INIT
  };
};